import React, { useState } from "react";
import "./Partnerapplyform.css";

// ปรับ URL นี้ให้ตรงกับ backend จริงของคุณ
// ถ้ามี axios instance ที่ตั้ง baseURL ไว้แล้วในโปรเจกต์ (เช่น utils/axios.js) แนะนำให้ import มาใช้แทน fetch ตรงนี้
const API_URL = process.env.REACT_APP_API_URL || "http://localhost:4000/api";

const initialForm = {
  name: "",
  phone: "",
  email: "",
  organization: "",
};

const PartnerApplyForm = ({ onSuccess }) => {
  const [form, setForm] = useState(initialForm);
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [status, setStatus] = useState(null); // "success" | "error" | null

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    // ล้าง error ของ field นั้นทันทีที่ผู้ใช้เริ่มพิมพ์ใหม่
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: null }));
    }
  };

  const validate = () => {
    const newErrors = {};

    if (!form.name.trim()) {
      newErrors.name = "กรุณากรอกชื่อผู้ติดต่อ";
    }

    if (!form.phone.trim()) {
      newErrors.phone = "กรุณากรอกเบอร์โทรศัพท์";
    } else if (!/^0[0-9]{8,9}$/.test(form.phone.trim())) {
      newErrors.phone = "รูปแบบเบอร์โทรศัพท์ไม่ถูกต้อง";
    }

    if (!form.email.trim()) {
      newErrors.email = "กรุณากรอกอีเมล";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email.trim())) {
      newErrors.email = "รูปแบบอีเมลไม่ถูกต้อง";
    }

    if (!form.organization.trim()) {
      newErrors.organization = "กรุณากรอกชื่อองค์กร/บริษัท";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus(null);

    if (!validate()) return;

    setSubmitting(true);
    try {
      const res = await fetch(`${API_URL}/partner`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });

      if (!res.ok) {
        const errData = await res.json().catch(() => ({}));
        throw new Error(errData.error || "ส่งข้อมูลไม่สำเร็จ");
      }

      setStatus("success");
      setForm(initialForm);
      if (onSuccess) {
        setTimeout(() => onSuccess(), 1500);
      }
    } catch (err) {
      console.error(err);
      setStatus("error");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="partner-form-wrap" id="partner-apply-form">
      <h4 className="partner-form-title">สมัครเป็นพันธมิตรกับเรา</h4>
      <p className="partner-form-desc">
        กรอกข้อมูลด้านล่าง ทีมงานจะติดต่อกลับภายใน 3-5 วันทำการ
      </p>

      {status === "success" && (
        <div className="partner-form-alert success">
          ✅ ส่งใบสมัครสำเร็จ! ทีมงานจะติดต่อกลับโดยเร็วที่สุด
        </div>
      )}
      {status === "error" && (
        <div className="partner-form-alert error">
          ❌ เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง
        </div>
      )}

      <form className="partner-form" onSubmit={handleSubmit} noValidate>
        <div className="partner-form-group">
          <label htmlFor="name">ชื่อผู้ติดต่อ</label>
          <input
            id="name"
            name="name"
            type="text"
            placeholder="ชื่อ นามสกุล"
            value={form.name}
            onChange={handleChange}
            className={errors.name ? "error" : ""}
          />
          {errors.name && <span className="field-error">{errors.name}</span>}
        </div>

        <div className="partner-form-group">
          <label htmlFor="phone">เบอร์โทรศัพท์</label>
          <input
            id="phone"
            name="phone"
            type="tel"
            placeholder=""
            value={form.phone}
            onChange={handleChange}
            className={errors.phone ? "error" : ""}
          />
          {errors.phone && (
            <span className="field-error">{errors.phone}</span>
          )}
        </div>

        <div className="partner-form-group">
          <label htmlFor="email">อีเมล</label>
          <input
            id="email"
            name="email"
            type="email"
            placeholder=""
            value={form.email}
            onChange={handleChange}
            className={errors.email ? "error" : ""}
          />
          {errors.email && (
            <span className="field-error">{errors.email}</span>
          )}
        </div>

        <div className="partner-form-group">
          <label htmlFor="organization">ชื่อองค์กร/บริษัท</label>
          <input
            id="organization"
            name="organization"
            type="text"
            placeholder=""
            value={form.organization}
            onChange={handleChange}
            className={errors.organization ? "error" : ""}
          />
          {errors.organization && (
            <span className="field-error">{errors.organization}</span>
          )}
        </div>

        <button
          type="submit"
          className="btn-partner-apply"
          disabled={submitting}
        >
          {submitting ? "กำลังส่งข้อมูล..." : "สมัครเป็นพันธมิตรทันที ✦"}
        </button>
      </form>
    </div>
  );
};

export default PartnerApplyForm;